import { createContext, useCallback, useContext, useMemo, useState } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { Nullable } from 'cng-common/models/utils'

export interface BackupContextType {
  backupedContact: Nullable<IContact>
  setBackupedContact: (contact: Nullable<IContact>) => void
}

export const BackupContext = createContext<BackupContextType | null>(null)

export const useBackup = (): BackupContextType => {
  const context = useContext(BackupContext)
  if (!context) {
    throw new Error('useBackup must be used within BackupProvider')
  }
  return context
}

export interface BackupProviderProps {
  children: React.ReactNode
}

export const BackupProvider: React.FC<BackupProviderProps> = ({ children }) => {
  const [backupedContact, setBackupedContactState] = useState<Nullable<IContact>>(null)

  const setBackupedContact = useCallback((contact: Nullable<IContact>) => {
    setBackupedContactState(contact)
  }, [])

  const value = useMemo(
    (): BackupContextType => ({
      backupedContact,
      setBackupedContact,
    }),
    [backupedContact, setBackupedContact]
  )

  return <BackupContext.Provider value={value}>{children}</BackupContext.Provider>
}
